import { render } from "./Settlement.vue?vue&type=template&id=68527e4b&ts=true"
import script from "./Settlement.vue?vue&type=script&lang=ts"
export * from "./Settlement.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__